module.exports = __webpack_public_path__ + "static/img/scene.16511666.svg";